import React from 'react';
import {
  string, number,
} from 'prop-types';
import isNil from 'lodash/isNil';
import { format } from '@active/core/currency/format';
import { connectCommonProps } from '../../../shared/utils/CommonPropsContext';

const I18nCurrency = ({
  locale = 'en_US', amount, code, abbreviated = false,
}) => {
  if (code && !isNil(amount)) {
    return <React.Fragment>{format(locale, { code, abbreviated })(amount)}</React.Fragment>;
  }
  return null;
};

const currency = ({
  amount, code, locale = 'en_US', abbreviated = false,
}) => {
  return code && !isNil(amount)
    ? format(locale, { code, abbreviated })(amount) : null;
};

I18nCurrency.propTypes = {
  locale: string,
  amount: number,
  code: string.isRequired,
};

export { currency };
export default connectCommonProps(I18nCurrency);
